export const LX_CONFIG = {
    COMP_MV_BID: 'b_daodian_lowcode_4lafjhsy_mv',
    CARD_MV_BID: 'b_daodian_lowcode_e0zrz1ix_mv',
    CARD_MC_BID: 'b_daodian_lowcode_mod3vjz4_mc'
};
export var SHOW_TYPE_ENUM;
(function (SHOW_TYPE_ENUM) {
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["TWO_LIST"] = 1] = "TWO_LIST";
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["SIGNAL_ROW"] = 2] = "SIGNAL_ROW";
})(SHOW_TYPE_ENUM || (SHOW_TYPE_ENUM = {}));
export const DYNAMIC_LIST_SCENE_TOKEN = 'dd-9cbc1c31cfbf2bba';
